module.exports = __webpack_public_path__ + "4fb55fff0806071b61f80f02eda6bf3d.png";